import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { SERVICES, GALLERY, PHONES, DEFAULT_TEXTS, IMAGES } from "@/data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ContentContext = createContext(null);

export function mergeContent(content) {
  const services = SERVICES.map((d) => ({ ...d, ...((content?.services || []).find((s) => s.slug === d.slug) || {}) }));
  const gallery = content?.gallery?.length ? content.gallery : GALLERY;
  const phones = content?.phones?.filter(Boolean).length ? content.phones : PHONES;
  const texts = { ...DEFAULT_TEXTS, ...(content?.texts || {}) };
  const heroImage = content?.heroImage || IMAGES.hero;
  const phoneLinks = phones.map((p) => `tel:+1${String(p).replace(/\D/g, "")}`);
  return { texts, services, gallery, phones, phoneLinks, heroImage };
}

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  const load = useCallback(() => {
    fetch(`${API}/content`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => setContent(data && Object.keys(data).length ? data : {}))
      .catch(() => setContent({}));
  }, []);

  useEffect(load, [load]);

  const value = { ...mergeContent(content), reload: load };
  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
